import { useEffect, useState } from 'react';
import { evaluationsAPI } from '../lib/api';

/**
 * Poll the user's "sign queue" count.
 *
 * Powers:
 *   - The red pill on the sidebar 'Evaluations' item
 *   - The dashboard tile
 *
 * Refresh cadence: 60 s (evaluations are not high-velocity so this is plenty
 * cheap). The hook silently returns 0 if the endpoint is unreachable or the
 * user has no employee record — no noise in the UI.
 */
export function useMySignQueueCount(enabled = true) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // Only users who can view evaluations have a sign queue. Polling the
    // capability-gated endpoint for everyone else produced a steady stream of
    // authorization DENYs in the audit log (notably for GSOC users). Gated here
    // so non-evaluations users never call it. Real denials elsewhere still log.
    if (!enabled) { setCount(0); return undefined; }
    let alive = true;
    let timer = null;
    const load = async () => {
      try {
        const res = await evaluationsAPI.mySignQueue();
        if (alive) setCount((res.data || []).length);
      } catch (_e) {
        if (alive) setCount(0);
      }
    };
    load();
    timer = setInterval(load, 60_000);
    return () => { alive = false; if (timer) clearInterval(timer); };
  }, [enabled]);

  return count;
}
